import React from 'react';
import ListPageHeader from '@shared/ListPageHeader';
import AccessibleIpAddressesList from '@shared/accessible_ip_addresses/AccessibleIpAddressesList';
import { accessibleIpAddressService } from '@services/admin/accessibleIpAddressService';

const AdminAccessibleIpAddressesList: React.FC = () => {
  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['settings', 'settings.accessible_ip_addresses']}
      />
      <AccessibleIpAddressesList
        accessibleIpAddressService={accessibleIpAddressService}
        role="admin"
        hideCardHeader
      />
    </div>
  );
};

export default AdminAccessibleIpAddressesList;
